import React from 'react';
import type ReactType from 'react';
import cls from 'classnames';
import * as S from './styled';

export interface Props {
  className?: string | string[] | Record<string, unknown>;
  newStyle?: boolean;
  borderTop?: boolean;
}

const ModalButtons: ReactType.FC<Props> = (props) => {
  return (
    <S.ModalButton
      $newStyle={props.newStyle}
      $borderTop={props.borderTop}
      className={cls('ModalButtons', props.className)}
    >
      {props.children}
    </S.ModalButton>
  );
};

export default ModalButtons;
